import { BaseTable, CommandButton, JournalTable, Loading, Modal, TableHeader } from "components"
import { Fragment } from "react"
import { useFormContext } from "react-hook-form"
import { convertNumber, useCoaBsi, useCoaByCode, useTaxCode, useToggle } from "utils"
import { FormType } from "../utils"
import moment from "moment"

export function Journal() {
    const { isActive, toggle } = useToggle(false)

    return (
        <Fragment>
            <CommandButton actiontype="journal" onClick={toggle} />

            {isActive && (
                <Modal isOpen title="JOURNAL" closeModal={toggle} size="full">
                    <Modal.Body>
                        <JournalTableSection />
                    </Modal.Body>
                </Modal>
            )}
        </Fragment>
    )
}

function JournalTableSection() {
    const { getValues } = useFormContext<FormType>()
    const transaction_date = getValues('transaction_date')
    const trx_code = getValues('trx_code')
    const detailTransaction = getValues('prorejectdetail')


    return (
        <JournalTable>
            <JournalTable.Content>
                <BaseTable>
                    <TableHeader>
                        <tr>
                            <th className="w-[10px]">DATE</th>
                            <th>IDM</th>
                            <th>ACCOUNT</th>
                            <th>DEBET</th>
                            <th>CREDIT</th>
                        </tr>
                    </TableHeader>
                    <tbody>
                        {detailTransaction.map((item, index) => {
                            const amount = Math.round(item.quantity_reject * item.price_reject * (100 - item.discount) / 100)
                            const amountTax = Math.round(amount * item.tax_rate / 100)

                            return (
                                <Fragment key={index}>
                                    {Boolean(amount) && (
                                        <>
                                            <tr>
                                                <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                <td>{trx_code}</td>
                                                <LinkedAccount />
                                                <td className="text-right">{convertNumber(amount).intoCurrency}</td>
                                                <td></td>
                                            </tr>

                                            <tr>
                                                <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                <td>{trx_code}</td>
                                                <ProductInventory product_id={item.product_id.toString()} />
                                                <td></td>
                                                <td className="text-right">{convertNumber(amount).intoCurrency}</td>
                                            </tr>
                                        </>
                                    )}

                                    {Boolean(item.tax_id && item.tax_rate > 0) && (
                                        <>
                                            <tr>
                                                <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                <td>{trx_code}</td>
                                                <LinkedAccount />
                                                <td className="text-right">{convertNumber(amountTax).intoCurrency}</td>
                                                <td></td>
                                            </tr>

                                            <tr>
                                                <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                <td>{trx_code}</td>
                                                <TaxAccount tax_id={item.tax_id.toString()} />
                                                <td></td>
                                                <td className="text-right">{convertNumber(amountTax).intoCurrency}</td>
                                            </tr>
                                        </>
                                    )}
                                </Fragment>
                            )
                        })}
                    </tbody>
                </BaseTable>
            </JournalTable.Content>
        </JournalTable>
    )
}

function ProductInventory(params: {
    product_id: string
}) {
    const { data, isLoading } = useCoaBsi(params.product_id)

    if (isLoading) {
        return (
            <td>
                <Loading loading />
            </td>
        )
    }

    return <td>{data}</td>
}


function LinkedAccount() {
    const { data, isLoading } = useCoaByCode('LA11')

    if (isLoading) {
        return (
            <td>
                <Loading loading />
            </td>
        )
    }

    return <td>{data}</td>
}

function TaxAccount(params: {
    tax_id: string
}) {
    const { data, isLoading } = useTaxCode()
    const selectedTaxCode = data.find(i => i.value === params.tax_id)

    if (isLoading) {
        return (
            <td>
                <Loading loading />
            </td>
        )
    }
    return <td>{selectedTaxCode?.tax_coa_paid}</td>
}